export interface Supplier {
  id: number;
  name: string;
}
